import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-stone-50 flex flex-col">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} isHomePage={false} />
      
      <main className="flex-grow pt-28 pb-20">
        <div className="max-w-4xl mx-auto px-6 bg-white p-10 md:p-16 rounded-3xl shadow-sm border border-blue-100">
          <h1 className="text-3xl md:text-5xl font-bold text-blue-900 mb-8 font-serif">Privacy Policy</h1>
          
          <div className="prose prose-blue max-w-none text-stone-600 space-y-6">
            <p>
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
            
            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">1. Introduction</h2>
              <p>
                Welcome to Sky's PhysioRehab & Slimming Centre. We respect your privacy and are committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you visit our website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">2. Information We Collect</h2>
              <p>We may collect, use, store, and transfer different kinds of personal data about you when you use our contact or booking forms, which may include:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li><strong>Identity Data:</strong> First name, last name.</li>
                <li><strong>Contact Data:</strong> Phone number, email address.</li>
                <li><strong>Health-related Data:</strong> Optional information you provide about your medical condition (e.g., Diastasis Recti concerns, post-pregnancy recovery) in the message field.</li>
                <li><strong>Technical Data:</strong> Internet protocol (IP) address, browser type, time zone setting, operating system, and data collected via Google Analytics.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">3. How We Use Your Information</h2>
              <p>We use your personal data to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Respond to your inquiries and schedule appointments.</li>
                <li>Communicate with you regarding our services via phone, WhatsApp, or email.</li>
                <li>Improve our website performance and user experience (e.g., via Google Analytics).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">4. Data Security</h2>
              <p>
                We have implemented appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed. We limit access to your personal data to those employees and partners who have a business need to know.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">5. Third-Party Links & Tracking</h2>
              <p>
                This website may include links to third-party websites or applications like WhatsApp. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We use Google Analytics to monitor and analyze web traffic and user behavior.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-800 mb-3 mt-8 font-serif">6. Contact Us</h2>
              <p>
                If you have any questions about this privacy policy or our privacy practices, please contact us at:
              </p>
              <p className="mt-2 text-blue-900 font-semibold">
                Sky's PhysioRehab & Slimming Centre<br/>
                Phone: +91 88000 95625<br/>
                Location: 3/173, Vikrant Khand 3, Gomti Nagar, Lucknow - 226010
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
